import React,{useEffect,useRef, useState, useLayoutEffect} from "react";
import { useAppDispatch,useAppSelector } from "../../../app/hooks";
import { getAccountStatusAsync,resetSelectedRecordObjectInState,DeleteSelectedAccountStatusAsync, deleteAccountStatusAsync,updatePagination } from "./StatusSlice";
import { StatusItem } from "./StatusItem";
import { StatusForm } from "./StatusForm";
import StatusTypeOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import CustomPagination from "../../../common/Pagination";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';


import { updateIsLoading } from "../employee/employeeSlice";
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

export const Status = () =>{

    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { StatusList, isReload, selectedRecord,isLoading,sortOrder, sortColumn, search, pageNo, pageSize  } = useAppSelector((state) => state.status);
     const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, manageTerminologyList } = useAppSelector((state) => state.globalState);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

 

    // const filteredData: any = getFilteredList(StatusList, searchTerm);

    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = StatusList.length;
    // const recordsFiltered = filteredData.length;

    const filteredData: any = getFilteredList(StatusList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = StatusList.length;
    const recordsFiltered = filteredData.length;

    useEffect(() => {
        if (isReload) {
            dispatch(getAccountStatusAsync());
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getAccountStatusAsync());
    }, [dispatch])

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setIsModalOpen(true);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountStatusAsync(StatusList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Status deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }

    return (
        <>
 {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1"  >
                        {/* {t('Status')} */}
                        {getValueFromResource('Status', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-status"
                            data-tooltip-content={getValueFromResource('Configure the available status values for different record types, such as Employee, Project, Task, and others. Each status category can have its own set of custom statuses.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                 <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {(IsAdd || (IsDelete && StatusList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        } */}
                         {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    />
                                </div>
                            </>
                        )}

                        {(IsAdd || (IsDelete && StatusList.some((item: any) => item.isSelected === 1))) && (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        )}
                        {IsAdd &&
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: StatusList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Status Type')} */}
                                {getValueFromResource('Add Status Type',dispatch, t)}
                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: StatusList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{StatusList.filter((item: any) => item.isSelected === 1).length}</span> 
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected',dispatch, t)}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: StatusList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}
                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <StatusItem StatusList={currentItems} modelRef={modelRef} t={t} onopenModal={openModal} oncloseModal={closeModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }
            </div>


    
            {isModalOpen &&
                <StatusForm modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
            <ReactTooltip
                id="tooltip-status"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
  
}